import React from 'react'
import { Modal } from 'antd'

import history from '@/utils/history'
import { useGlobalContext } from '@/components/context'
import { useFormContext } from '@/state/main-form/reducer'
import { formUrl } from '@/utils/url'
import { FieldRow } from './field-row'

export const ModifyFormModal = () => {
	const { user } = useGlobalContext()
	const formContext = useFormContext()
	const globalContext = useGlobalContext()

	const fields = (
		Object.keys(formContext.fields).map(id => formContext.fields[id]).filter(field => !field.llmMemory).sort(f => f.rank)
	)
	
	if (!user.topLevelManager) {
		return null
	}

	return (
		<Modal
			title="Modify form fields"
			open
			maskClosable
			onCancel={() => history.push(formUrl({recordId: formContext.record.id, formId: formContext.form.id, ...globalContext}))}
			footer={null}
			width={600}
		>
			<p>
				Select the fields for this form. These changes will apply for <b>all</b> {globalContext.currentModule.recordWord.toLocaleLowerCase()}s
				in this {globalContext.currentModule.teamWord}.
			</p>
			<br/>
			{fields.map(f => (
				<div key={f.id}>
					<FieldRow fieldId={f.id} />
				</div>
			))}
		</Modal>
	)
}
